import { cn } from '@/lib/cn';
import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

interface DesktopControlApprovalWarningProps {
  message: ReactNode;
  className?: string;
}

export const DesktopControlApprovalWarning = ({
  message,
  className,
}: DesktopControlApprovalWarningProps) => (
  <div
    className={cn(
      'flex items-start gap-2 rounded-md border border-validation-warning-border bg-validation-warning-muted/40 px-2.5 py-1.5 text-xs text-validation-warning',
      className
    )}
  >
    <AlertTriangle className="mt-0.5 size-3.5 shrink-0" />
    <span className="break-words [overflow-wrap:anywhere]">{message}</span>
  </div>
);
